import Cookies from 'js-cookie';
import { v4 } from 'uuid';
import { LocationState } from 'history';
import SETTINGS from 'core/settings';
import WebApi from 'core/services/WebApi';
import { generateSnackbarKey } from 'core/components/layout/Notifier';
import { AppThunk } from 'redux/store';
import {
  TypesLayout,
  IProgressStartAction,
  IProgressEndAction,
  // ISetIsSuccessAction,
  // ISetMessageAction,
  IEnqueueSnackbarAction,
  ICloseSnackbarAction,
  IRemoveSnackbarAction,
} from './type';
import { IAlert } from '../../reducers/layout/type';

export const redirect =
  (url: string, locationState?: LocationState): AppThunk<void> =>
  (dispatch, getState) => {
    const state = getState();
    const langPath = state.layout.languagePath;

    return dispatch({ type: TypesLayout.REDIRECT, url: `${langPath}${url}`, state: locationState });
  };

export const progressStart: IProgressStartAction = (url, isModal) => {
  return { type: TypesLayout.PROGRESS_START, url, isModal };
};

export const progressEnd: IProgressEndAction = (url, isModal) => {
  return { type: TypesLayout.PROGRESS_END, url, isModal };
};
export const enqueueSnackbar: IEnqueueSnackbarAction = (notification) => {
  return {
    type: TypesLayout.ENQUEUE_SNACKBAR,
    notification: {
      ...notification,
      key: generateSnackbarKey(),
    },
  };
};

export const closeSnackbar: ICloseSnackbarAction = (key) => ({
  type: TypesLayout.CLOSE_SNACKBAR,
  dismissAll: !key, // dismiss all if no key has been defined
  key: key,
});

export const removeSnackbar: IRemoveSnackbarAction = (key) => ({
  type: TypesLayout.REMOVE_SNACKBAR,
  key,
});

export const getLayoutInfo = (): AppThunk<void> => (dispatch, getState) => {
  const state = getState();
  const lang = state.layout.language;

  dispatch({ type: TypesLayout.GET_LAYOUT_INFO_REQUEST });

  return WebApi.request({
    method: 'GET',
    url: '/data',
    data: { lang: lang },
    isWP: true,
    onSuccess: (data) => {
      dispatch({ type: TypesLayout.GET_LAYOUT_INFO_SUCCESS, data: data });
    },
    isAuth: false,
  });
};

export const login =
  (token: string, onLogin?: () => void): AppThunk<void> =>
  () => {
    Cookies.set(SETTINGS.authTokenStorage, token, {
      sameSite: 'Strict',
      secure: true,
    });
    onLogin && onLogin();
  };

export const logout =
  (onLogout?: () => void): AppThunk<void> =>
  (dispatch) => {
    dispatch({ type: TypesLayout.LOGOUT });
    Cookies.remove(SETTINGS.authTokenStorage);
    localStorage.clear();
    onLogout && onLogout();
  };

export const setAlert: (alert: Omit<IAlert, 'id'>) => AppThunk<void> =
  (alert): AppThunk<void> =>
  (dispatch, getState) => {
    const id = v4();
    const state = getState();
    const candidate = state.layout.alerts.find(
      (item) => item.textData.message === alert.textData.message
    );

    !candidate &&
      dispatch({
        type: TypesLayout.SET_ALERT,
        alert: { ...alert, id },
      });
  };

export const removeAlert = (alertId: number) => ({
  type: TypesLayout.REMOVE_ALERT,
  alertId,
});
